/* fuga-niche-directory.js V4 "Director's Cut" — /pages/niches.
   Hero: Word-Stagger + Ghost-Marquee + Scroll-Exit · Kapitel: Letter-Stagger,
   choreografierte Reveals (Media von Flip-Seite, Copy-Drift), Kamerafahrt,
   Sticky-Numeral · Orbit-Hover-Preview (lazy, lerp) · Phasen-Dots · TOC-Tone+Progress ·
   Snap-Assist. transform/opacity-only · prefers-reduced-motion => statisch. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var root = document.querySelector('.fuga-nd');
  if (!root) return;

  var toc = root.querySelector('[data-nd-toc]');
  var tocLinks = [].slice.call(root.querySelectorAll('[data-nd-toc-link]'));
  var chapters = [].slice.call(root.querySelectorAll('[data-nd-chapter][id]'));
  var allPlates = [].slice.call(root.querySelectorAll('[data-nd-chapter], .fuga-nd__cta'));

  /* ---------- Phasen-Dots (Desktop) ---------- */
  var dotBtns = [];
  if (chapters.length && fine && window.innerWidth > 1100) {
    var dots = document.createElement('nav');
    dots.className = 'fuga-nd__dots';
    dots.setAttribute('aria-label', 'Phasen');
    chapters.forEach(function (c, i) {
      var label = c.querySelector('.fuga-nd__chapter-h');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fuga-nd__dot';
      b.setAttribute('aria-label', (label ? label.textContent.trim() : 'Phase ' + (i + 1)));
      b.innerHTML = '<span class="fuga-nd__dot-tip">0' + (i + 1) + ' ' + (label ? label.textContent.trim().replace(/\.$/, '') : '') + '</span>';
      b.addEventListener('click', function () {
        c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      dots.appendChild(b);
      dotBtns.push(b);
    });
    document.body.appendChild(dots);
  }

  /* ---------- TOC active + tone + Dots sync ---------- */
  if (toc && allPlates.length && 'IntersectionObserver' in window) {
    var byId = {};
    tocLinks.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var tocIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var black = en.target.classList.contains('fuga-collection-story--black') || en.target.classList.contains('fuga-nd__plate--black');
        toc.setAttribute('data-tone', black ? 'black' : 'cream');
        if (!en.target.id) return;
        tocLinks.forEach(function (a) { a.classList.remove('is-active'); });
        var a = byId[en.target.id];
        if (a) a.classList.add('is-active');
        var ci = chapters.indexOf(en.target);
        dotBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === ci); });
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    allPlates.forEach(function (c) { tocIO.observe(c); });
  }

  /* ---------- Smooth-Anchor auf Klick ---------- */
  [].slice.call(root.querySelectorAll('[data-nd-toc-link], .fuga-nd__next a')).forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.getElementById(id.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', id);
    });
  });

  if (reduce) return;

  /* ---------- Hero: Statement in Wörter splitten ---------- */
  var heroInner = root.querySelector('[data-nd-hero-inner]');
  var heroEl = root.querySelector('[data-nd-hero]');
  var st = root.querySelector('.fuga-nd__hero .fuga-nd__statement');
  if (st) {
    var words = st.textContent.split(' ');
    st.setAttribute('aria-label', st.textContent);
    st.innerHTML = '';
    words.forEach(function (w, i) {
      var wrap = document.createElement('span');
      wrap.className = 'nd-wm';
      wrap.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.className = 'nd-w';
      inner.style.transitionDelay = (300 + i * 70) + 'ms';
      inner.textContent = w;
      wrap.appendChild(inner);
      st.appendChild(wrap);
      st.appendChild(document.createTextNode(' '));
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { st.classList.add('nd-w-in'); });
    });
  }

  /* ---------- Kapitel-Headlines: Letter-Stagger ---------- */
  [].slice.call(root.querySelectorAll('.fuga-nd__chapter-h > a')).forEach(function (a) {
    var text = a.textContent;
    a.setAttribute('aria-label', text);
    a.classList.add('nd-letters');
    a.innerHTML = '';
    text.split('').forEach(function (ch, i) {
      var s = document.createElement('span');
      s.className = 'nd-ch';
      s.setAttribute('aria-hidden', 'true');
      s.style.transitionDelay = (i * 26) + 'ms';
      s.textContent = ch === ' ' ? ' ' : ch;
      a.appendChild(s);
    });
  });

  /* ---------- Reveal-Choreografie ---------- */
  [].slice.call(root.querySelectorAll(
    '.fuga-collection-story__chip, .fuga-nd__chips-list > li, .fuga-product-strip__grid > *'
  )).forEach(function (el) { el.setAttribute('data-nd-reveal', ''); });
  /* Media schiebt von der Flip-Seite rein */
  [].slice.call(root.querySelectorAll('.fuga-nd__chapter .fuga-nd__media')).forEach(function (mediaEl) {
    var flip = mediaEl.closest('.fuga-collection-story--flip') !== null;
    mediaEl.setAttribute('data-nd-reveal', '');
    mediaEl.classList.add(flip ? 'nd-from-r' : 'nd-from-l');
  });

  var groups = root.querySelectorAll('.fuga-nd__hero, .fuga-nd__chapter, .fuga-nd__plate');
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var t = en.target;
          if (t.__ndh) { t.classList.add('nd-letters-in'); io.unobserve(t); return; }
          t.style.transitionDelay = (t.__ndi * 55) + 'ms';
          t.classList.add('nd-in');
          io.unobserve(t);
        });
      }, { rootMargin: '0px 0px 10% 0px', threshold: 0.01 })
    : null;
  Array.prototype.forEach.call(groups, function (plate) {
    var els = plate.querySelectorAll('[data-nd-reveal]');
    Array.prototype.forEach.call(els, function (el, i) {
      el.__ndi = Math.min(i, 10);
      if (io) { el.classList.add('nd-pre'); io.observe(el); }
    });
    var h = plate.querySelector('.fuga-nd__chapter-h > a.nd-letters');
    if (h && io) { h.__ndh = true; io.observe(h); }
  });

  /* ---------- Orbit-Hover-Preview (Desktop, lazy, lerp) ---------- */
  var pv = null, pvImg = null, pvX = 0, pvY = 0, pvTX = 0, pvTY = 0, pvOn = false;
  if (fine && window.innerWidth > 1000) {
    pv = document.createElement('div');
    pv.className = 'fuga-nd__preview';
    pv.setAttribute('aria-hidden', 'true');
    pvImg = document.createElement('img');
    pvImg.alt = '';
    pv.appendChild(pvImg);
    document.body.appendChild(pv);
    [].slice.call(root.querySelectorAll('.fuga-nd__sat[data-nd-img]')).forEach(function (sat) {
      sat.addEventListener('mouseenter', function () {
        pvImg.src = sat.getAttribute('data-nd-img');
        pvOn = true;
        pv.classList.add('is-on');
      });
      sat.addEventListener('mouseleave', function () {
        pvOn = false;
        pv.classList.remove('is-on');
      });
      sat.addEventListener('mousemove', function (e) {
        pvTX = e.clientX;
        pvTY = e.clientY;
      });
    });
  }

  /* ---------- rAF-Loop: Parallax, Numeral, Copy-Drift, Hero-Exit, Progress, Preview-Lerp ---------- */
  var imgs = [].slice.call(root.querySelectorAll('[data-nd-parallax]'));
  var ghosts = [].slice.call(root.querySelectorAll('[data-nd-ghost]'));
  var copies = [].slice.call(root.querySelectorAll('.fuga-nd__chapter .fuga-collection-story__copy'));
  var firstCh = chapters[0] || null;
  var lastCh = chapters.length ? chapters[chapters.length - 1] : null;
  var ticking = false;
  var rafLive = false;

  function progressOf(el, vh) {
    var r = el.getBoundingClientRect();
    if (r.bottom < -160 || r.top > vh + 160) return null;
    return (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    imgs.forEach(function (img) {
      var frame = img.closest('.fuga-nd__media') || img.parentElement;
      var p = progressOf(frame, vh);
      if (p === null) return;
      var ap = Math.min(Math.abs(p), 1);
      img.style.transform = 'translate3d(0,' + (p * -12).toFixed(3) + '%,0) scale(' + (1 + ap * 0.10).toFixed(4) + ')';
    });
    ghosts.forEach(function (g) {
      var host = g.closest('.fuga-nd__chapter') || g.parentElement;
      var p = progressOf(host, vh);
      if (p === null) return;
      g.style.transform = 'translate3d(0,' + (p * 60).toFixed(1) + 'px,0)';
      g.style.opacity = (0.05 + (1 - Math.min(Math.abs(p), 1)) * 0.07).toFixed(3);
    });
    copies.forEach(function (c) {
      var p = progressOf(c.closest('.fuga-nd__chapter'), vh);
      if (p === null) return;
      c.style.transform = 'translate3d(0,' + (p * 26).toFixed(1) + 'px,0)';
    });
    if (heroEl && heroInner) {
      var hr = heroEl.getBoundingClientRect();
      if (hr.bottom > 0) {
        var hp = Math.min(Math.max(-hr.top / Math.max(hr.height, 1), 0), 1);
        heroInner.style.transform = 'translate3d(0,' + (hp * 90).toFixed(1) + 'px,0) scale(' + (1 - hp * 0.06).toFixed(4) + ')';
        heroInner.style.opacity = (1 - hp * 1.1).toFixed(3);
      }
    }
    if (toc && firstCh && lastCh) {
      var top = firstCh.getBoundingClientRect().top;
      var bottom = lastCh.getBoundingClientRect().bottom;
      var span = bottom - top;
      var prog = span > 0 ? Math.min(Math.max((vh * 0.5 - top) / span, 0), 1) : 0;
      toc.style.setProperty('--nd-prog', prog.toFixed(4));
    }
  }

  function lerpLoop() {
    if (pv && (pvOn || Math.abs(pvX - pvTX) > 0.5 || Math.abs(pvY - pvTY) > 0.5)) {
      pvX += (pvTX - pvX) * 0.16;
      pvY += (pvTY - pvY) * 0.16;
      pv.style.transform = 'translate3d(' + (pvX + 26).toFixed(1) + 'px,' + (pvY - 120).toFixed(1) + 'px,0)' + (pvOn ? ' scale(1)' : ' scale(.96)');
    }
    requestAnimationFrame(lerpLoop);
  }
  if (pv) requestAnimationFrame(lerpLoop);

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
